import { combineReducers } from 'redux';
import { dashboardManagerReducer } from '@domain/dashboard/dashboard-manager/dashboard-manager.state';
import { dashboadManagerMiddleware } from '@domain/dashboard/dashboard-manager/dashboard-manager.middlewares';
import { hotSpotReducer } from './hotspot/hot-spot-container/hot-spot-container.state';
import { hotSpotCategoryReducer } from './hotspot/hot-spot-categories/hot-spot-categories.state';
import { hotSpotModalReducer } from './hotspot/hot-spot-modal/hot-spot-modal.state';
import { metricsReportReducer, metricsReportsMiddleware } from './metrics-report';
import { campaignsReducer } from './campaigns/campaigns.state';
import { budgetManagerReducer } from './budget-manager/budget-manager.state';
import { clusterReducer } from './cluster/cluster.state';
import { conversionTypesMiddleware, conversionTypesReducer } from './conversion-types';
import { dashboardMiddleware } from './dashboard.middlewares';
import { dashboardFiltersMiddleware, dashboardFiltersReducer } from './dashboard-filters';
import { tagsReducer } from './tags/tags.state';
import { tagsMiddleware } from './tags/tags.middleware';

export default combineReducers({
    hotSpots: hotSpotReducer,
    hotSpotsCategories: hotSpotCategoryReducer,
    hotSpotModal: hotSpotModalReducer,
    metricsReport: metricsReportReducer,
    campaigns: campaignsReducer,
    dashboardFilters: dashboardFiltersReducer,
    budgetManager: budgetManagerReducer,
    clusters: clusterReducer,
    conversionTypes: conversionTypesReducer,
    tags: tagsReducer,
    dashboardManager: dashboardManagerReducer,
});

export const dashboardMiddlewares = [
    conversionTypesMiddleware,
    dashboardMiddleware,
    metricsReportsMiddleware,
    dashboardFiltersMiddleware,
    tagsMiddleware,
    dashboadManagerMiddleware,
];
